var CAPI_WORKER_URL = 'https://domani-meta-capi.joey-7d0.workers.dev/';
var PIXEL_ID = '25888892234094160';

document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('form[action^="/contact"]');
  if (!form) return;

  form.addEventListener('submit', function () {
    var data = {};
    new FormData(form).forEach(function (value, key) { data[key] = value; });

    var email     = data['contact[email]'] || '';
    var phone     = data['contact[phone]'] || data['contact[Phone Number]'] || data['contact[Numéro de téléphone]'] || '';
    var firstName = data['contact[first_name]'] || '';
    var lastName  = data['contact[last_name]'] || '';
    if (!firstName) {
      var fullName = data['contact[Name]'] || data['contact[Nom]'] || '';
      if (fullName) {
        var parts = fullName.trim().split(' ');
        firstName = parts[0] || '';
        lastName  = parts.slice(1).join(' ') || '';
      }
    }

    var eventId = 'lead-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);

    // Browser pixel — Lead event (fires before page navigates to /pages/merci)
    if (window.fbq) {
      fbq('track', 'Lead', {
        content_name: 'Domani Audit Request',
        content_category: 'Agency Services',
        currency: 'CAD',
        value: 0
      }, { eventID: eventId });
    }

    // Server-side CAPI via Cloudflare Worker
    // keepalive: true ensures the request completes even after page navigation
    if (CAPI_WORKER_URL !== 'REPLACE_WITH_CLOUDFLARE_WORKER_URL') {
      fetch(CAPI_WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          eventId: eventId,
          email: email,
          phone: phone,
          firstName: firstName,
          lastName: lastName,
          sourceUrl: window.location.href,
          fbp: getCookie('_fbp'),
          fbc: getCookie('_fbc')
        })
      }).catch(function () {});
    }

    // Google Ads conversion fires on /pages/merci page load (server-confirmed redirect)
  });

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }
});
